import { Environment, getCurrentEnvironment } from '../../util/environments'
import { getOrigin } from '../../util/origins'

export interface IConnector {
  title: string
  description: string
  link: string
  type: string
}

const currentEnvironment = getCurrentEnvironment()

const CloudHubMule3Connector: IConnector = {
  title: 'CloudHub - Mule 3',
  description: 'Respond to Anypoint Monitoring alert notifications in Mule 3',
  link: '/exchange/org.mule.modules/mule-module-cloudhub/',
  type: 'Mule-3-connector',
}

const CloudHubMule4Connector: IConnector = {
  title: 'CloudHub - Mule 4',
  description: 'Respond to Anypoint Monitoring alert notifications in Mule 4',
  link: '/exchange/com.mulesoft.connectors/mule-cloudhub-connector/',
  type: 'Mule-4-connector'
}

const tokenizationAPILink = () => {
  const origin = getOrigin(Environment.PROD)
  return `${origin}/exchange/portals/anypoint-platform/f1e97bc6-315a-4490-82a7-23abe036327a.anypoint-platform/tokenization-runtime-service-api/`
}

const LogTokenizationMule3Connector: IConnector = {
  title: 'Log Tokenization - Mule 3',
  description: 'Protect personally identifiable information (PII) and sensitive information from logs through Tokenization',
  link: tokenizationAPILink(),
  type: 'Mule-3-connector'
}

const LogTokenizationMule4Connector: IConnector = {
  title: 'Log Tokenization - Mule 4',
  description: 'Protect personally identifiable information (PII) and sensitive information from logs through Tokenization',
  link: tokenizationAPILink(),
  type: 'API-connector'
}

export const sourceConnectors = [
  CloudHubMule3Connector,
  CloudHubMule4Connector,
  LogTokenizationMule3Connector,
  LogTokenizationMule4Connector
]

const ServiceNowConnector: IConnector = {
  title: 'Service Now',
  description: 'Create tickets or incidents in ServiceNow in response to Anypoint Monitoring alert notifications',
  link: '/exchange/org.mule.modules/mule-module-servicenow/',
  type: 'Mule-3-connector'
}

const SalesforceServiceCloudConnector: IConnector = {
  title: 'Salesforce Service Cloud',
  description: 'Create tickets in Salesforce Service Cloud in response to Anypoint Monitoring alert notifications ',
  link: '/exchange/org.mule.modules/mule-module-sfdc/',
  type: 'Mule-3-connector'
}

const JIRAConnector: IConnector = {
  title: 'JIRA',
  description: 'Create JIRA incidents or items in response to Anypoint Monitoring alert notifications',
  type: 'Mule-3-connector',
  link: (() => {
    switch (currentEnvironment) {
      case Environment.DEV:
        return '/exchange/org.mule.modules/mule-module-jira/'
      case Environment.QA:
      case Environment.STG:
      case Environment.PROD_EU:
        return '/exchange/org.mule.modules/mule-module-jirarest-connector/'
      case Environment.LOCAL:
      case Environment.PROD:
      default:
        return '/exchange/org.mule.modules/jirarest-connector/'
    }
  })(),
}

const ZendeskConnector: IConnector = {
  title: 'Zendesk',
  description: 'Create Zendesk tickets in response to Anypoint Monitoring alert notifications',
  link: '/exchange/org.mule.modules/mule-module-zendesk/',
  type: 'Mule-3-connector'
}

const SlackConnector: IConnector = {
  title: 'Slack',
  description: 'Send Slack messages in response to Anypoint Monitoring alert notifications',
  type: 'Mule-3-connector',
  link: (() => {
    switch (currentEnvironment) {
      case Environment.QA:
      case Environment.STG:
        return '/exchange/org.mule.modules/mule-module-slack-connector/'
      default:
        return '/exchange/org.mule.modules/slack-connector/'
    }
  })(),
}

export const destinationConnectors = [
  ServiceNowConnector,
  SalesforceServiceCloudConnector,
  JIRAConnector,
  ZendeskConnector,
  SlackConnector
]